// extracted by mini-css-extract-plugin
export var auto = "_30-1";
export var spinner = "_30-0";